<template>
  <div class="xiangqing">
    <div class="xiangqingContainer">
      <div class="content1">
        <div class="picLunbo">
          <van-swipe @change="onchange">
            <van-swipe-item
              v-for="(item, index) in inContent.pictureList"
              :key="index"
              ><img :src="item.pictureurl" alt="" preview="index"
            /></van-swipe-item>
            <template #indicator>
              <div class="custom-indicator">
                {{ current + 1 }}/{{ interaction.picturecount }}
              </div>
            </template>
          </van-swipe>
        </div>
        <div class="word">{{ interaction.content }}</div>
        <div class="addr" v-if="interaction.hasOwnProperty('position')">
          <img src="../assets/images/dingwei.svg" alt="" />
          <div class="addrWord">{{ interaction.position }}</div>
        </div>
        <div class="date">{{ interaction.createtime }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";
import Vue from "vue";
import { Swipe, SwipeItem } from "vant";
import { Field } from "vant";
import { Overlay } from "vant";
import { Popup } from "vant";
import qs from "qs";
import { Dialog } from "vant";

import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import { Toast } from "vant";

Vue.use(Popup);

Vue.use(Overlay);

Vue.use(Field);

Vue.use(Swipe);
Vue.use(SwipeItem);
export default {
  mounted() {
    this.getContent();
    this.src = window.location.href;
  },
  data() {
    return {
      current: 0,
      isShowShare: false,
      isDianzanShow: true,
      isPinlunShow: false,
      isPinlunSel: true,
      isDianzanSel: false,
      inContent: Object,
      interaction: Object,
      commentList: [],
      pinlunContent: "",
      title: "失物招领",
      neirong: "一个App畅享全市政务服务",
      src: "",
      type1: "wxhy",
      type2: "wxpyq",
      type3: "wb",
      type4: "qqhy",
      type5: "qqkj",
    };
  },
  methods: {
    onchange(index) {
      this.current = index;
    },

    getContent() {
      this.$toast.loading({
        message: "信息获取中...",
        forbidClick: true,
      });
      let params = qs.stringify({
        id: this.$route.query.id,
      });
      this.$axios
        .post("appinteraction/appInteraction/getInteractionShare", params)
        .then((res) => {
          console.log(res);
          if (res.data.result !== 1) {
            Toast.clear();
            Dialog.alert({
              message: res.data.reason,
            }).then(() => {});
            return;
          }
          if (res.data.result === 1) {
            Toast.clear();
            console.log(res);
            this.inContent = res.data;
            res.data.interaction.createtime = this.getYMDHMS(
              res.data.interaction.createtime
            );
            this.interaction = res.data.interaction;
          }
        })
        .catch((err) => {
          Toast.clear();
          console.error(err);
          Dialog.alert({
            message: "接口调用失败",
          }).then(() => {});
          return;
        });
    },
    getYMDHMS(timestamp) {
      let time = new Date(timestamp);
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let hours = time.getHours();
      let minute = time.getMinutes();
      let second = time.getSeconds();

      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hours < 10) {
        hours = "0" + hours;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-indicator {
  position: absolute;
  right: 0.625rem;
  bottom: 0.625rem;
  padding: 0.25rem 0.625rem;
  font-size: 1.5rem;
  background: rgba(0, 0, 0, 0.1);
}
.xiangqing {
  background-color: #fff;
  padding-top: 2.625rem;
}
.xiangqingContainer {
  .content1 {
    padding: 0 2rem 1.75rem 2rem;
    .picLunbo {
      img {
        width: 42.875rem;
        height: 57.125rem;
      }
    }
    .word {
      margin-top: 1.75rem;
      font-size: 1.75rem;
      color: #19212a;
    }
    .addr {
      margin-top: 1.75rem;
      width: 73%;

      padding: 1.125rem 1.5rem;
      display: flex;
      align-items: center;
      background: #f7f7f7;
      border-radius: 2.25rem;
      .addrWord {
        font-size: 1.625rem;
        color: #878787;
        margin-left: 1rem;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .date {
      margin-top: 2.375rem;
      font-size: 1.5rem;
      color: #878787;
    }
  }
  .fenge {
    width: 100%;
    height: 1.25rem;
    background: #eef4f6;
  }
  .content2 {
    padding: 1.75rem 2rem 0 2rem;
    margin-bottom: 8rem;
    .Seldianzan {
      display: flex;
      align-items: center;
      .pinlun {
        height: 2.875rem;
        margin-right: 5.875rem;
        font-size: 1.75rem;
        color: #878787;
      }
      .active {
        color: #19212a;
        font-weight: bold;
        font-size: 1.875rem;
      }
      .xiahuaxian {
        height: 0.5rem;
        background: #338989;
        border-radius: 0.5rem;
        margin-top: 0.75rem;
      }
    }
    .pinlunList {
      margin-top: 2.875rem;
      .touxiang {
        img {
          width: 5rem;
        }
      }
      .InPinlunList {
        display: flex;
        margin-bottom: 3.625rem;

        .listContent {
          width: 100%;
          border-bottom: 1px solid #eaeaea;
          padding-bottom: 1.5rem;
          margin-left: 2.125rem;
          .xinxi {
            display: flex;
            justify-content: space-between;
            .phoneNum {
              font-size: 1.625rem;
              color: #555555;
              white-space: nowrap;
            }

            .date {
              color: #b0b0b0;
              margin-left: 18.75rem;
              font-size: 1.5rem;
              white-space: nowrap;
            }
          }
          .pinlunContent {
            margin-top: 1.375rem;
            font-size: 1.875rem;
            color: #383838;
          }
        }
      }
    }
  }
  .dibu1 {
    width: 100%;
    // height: 6.375rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-top: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.25rem 1.875rem;
    .shurukuang {
      display: flex;
      align-items: center;
      width: 68%;
      height: 4rem;
      background: #f7f8f8;
      border-radius: 2416px;
      padding-left: 2.125rem;
      img {
        width: 2.125rem;
      }
      .word {
        color: #888888;
        font-size: 1.75rem;
        margin-left: 1.25rem;
      }
    }
    .dibuDianzan {
      display: flex;

      align-items: center;
      img {
        width: 2.5rem;
        height: 2.5rem;
      }
      .dianzanWord {
        color: #555555;
        font-size: 1.5rem;
        white-space: nowrap;
      }
    }
    .share {
      img {
        width: 2.75rem;
      }
    }
  }
  .dibu2 {
    display: flex;
    align-items: center;

    padding: 1.5rem 2.375rem 1.25rem 2rem;
    input {
      width: 36.125rem;
      height: 5.5rem;
      border: none;
      background: #f3f5f7;
      border-radius: 3rem;
      padding-left: 2.5rem;
      font-size: 2rem;
      color: #878787;
    }
    .fabuWord {
      color: #338989;
      font-weight: bold;
      font-size: 2rem;
      margin-left: 2.375rem;
      white-space: nowrap;
    }
  }
}
.shareWayList {
  padding: 0 1rem 1.5rem 1rem;
  display: flex;
  flex-wrap: wrap;
  .everyShare {
    width: 25%;
    display: flex;
    justify-content: center;
    margin-top: 3.125rem;
    .shareIcon {
      img {
        width: 6.5rem;
      }
    }
    .shareName {
      color: #555555;
      font-size: 1.625rem;
      margin-top: 1rem;
      text-align: center;
    }
  }
}
.fenge {
  width: 100%;
  height: 1.25rem;
  background: #eef4f6;
}
.dibuQuxiao {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 6.375rem;
  .word {
    color: #19212a;
    font-size: 2rem;
  }
}
</style>
<style lang="scss" scoped>
.picLunbo ::v-deep .van-swipe .van-swipe__track .van-swipe-item {
  width: 42.875rem !important;
  height: 57.125rem;

  img {
    border-radius: 1rem;
  }
}
.picLunbo ::v-deep .custom-indicator {
  position: absolute;
  right: 2rem;
  bottom: 2.375rem;
  padding: 0.25rem 1.5rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.85);
  border-radius: 1.375rem;
}
</style>
